import { render, staticRenderFns } from "./Technical_Analysis.vue?vue&type=template&id=be8dfdde&scoped=true&"
import script from "./Technical_Analysis.vue?vue&type=script&lang=js&"
export * from "./Technical_Analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8dfdde",
  null
  
)

export default component.exports